"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

function allSettled(arrayOrPromise) {
  return _q.default.Promise.resolve(arrayOrPromise).then(function (promises) {
    return _q.default.Promise.all(promises.map(function (promise) {
      return _q.default.Promise.resolve(promise).then(function (value) {
        return {
          state: 'fulfilled',
          value: value
        };
      }).catch(function (reason) {
        return {
          state: 'rejected',
          reason: reason
        };
      });
    }));
  });
}

var _default = allSettled;
exports.default = _default;
module.exports = exports.default;